import AemButton from '@/components/Aem/AemButton';
import {ArrowSmallIcon} from '@/components/Icons';
import amplitudeLoyaltyTracking from '@/services/analytics/amplitude/amplitudeLoyaltyTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import appContent from '@/services/content/appContent';
import appRouterService from '@/services/route/appRouterService';

import BadgeProgressContainer from './BadgeProgressContainer';

const FinishWhatYouStarted = ({journeys}) => {
    const MAX_JOURNEYS_TO_DISPLAY_COUNT = 2;
    const journeysToDisplay = journeys.slice(0, MAX_JOURNEYS_TO_DISPLAY_COUNT);
    const content = appContent.getFinishWhatYouStartedContent();

    if (!content) return null;

    const {
        title,
        viewAllButton,
        actionRemainingTitle,
        levelRemainingTitle,
        levelsRemainingTitle,
        actionsRemainingTitle,
        externalLink,
    } = content;

    const onViewAllClick = () => {
        amplitudeLoyaltyTracking.trackViewAllButtonClick();
        googleAnalyticsService.trackViewAllButtonClick();
        appRouterService.forwardToLoyaltyPage();
    };

    return (
        <>
            <div className='flex items-center justify-between gap-4'>
                <h2 className='m-0 truncate text-start text-24 font-bold md:text-28 lg:text-32'>{title}</h2>
                <AemButton
                    className='shrink-0'
                    textClassName='tracking-05'
                    onClick={onViewAllClick}
                    raw
                    {...viewAllButton}
                >
                    <ArrowSmallIcon />
                </AemButton>
            </div>
            <div
                className='mt-4 flex flex-col gap-1 overflow-hidden rounded-xl ml:grid ml:grid-cols-2 ml:gap-4'
                role='list'
            >
                {journeysToDisplay?.map((journey, index) => (
                    <div role='listitem' key={index}>
                        <BadgeProgressContainer
                            journey={journey}
                            actionRemainingTitle={actionRemainingTitle}
                            levelRemainingTitle={levelRemainingTitle}
                            actionsRemainingTitle={actionsRemainingTitle}
                            levelsRemainingTitle={levelsRemainingTitle}
                            externalLink={externalLink}
                        />
                    </div>
                ))}
            </div>
        </>
    );
};

export default FinishWhatYouStarted;
